"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISDESubsidy2022 = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const solution_1 = require("../solution");
const sum_1 = require("../utils/sum");
const calculator_1 = require("./calculator");
const types_1 = require("./types");
const utils_1 = require("./utils");
class ISDESubsidy2022 extends calculator_1.ISDESubsidyCalculator {
    constructor() {
        super(...arguments);
        this.year = 2022;
        this.bySolution = {
            [solution_1.Solution.AtticFloorInsulation]: new types_1.SubsidyDetails(8, { min: 20, max: 200 }),
            [solution_1.Solution.CentralHeatingBoiler]: null,
            [solution_1.Solution.ChargingBox]: null,
            [solution_1.Solution.CrawlspaceInsulation]: new types_1.SubsidyDetails(6, { min: 20, max: 130 }),
            [solution_1.Solution.ElectricHeatPump]: new types_1.SubsidyDetails(3100, { min: 1, max: 3 }),
            [solution_1.Solution.AirToAirHeatPump]: null,
            [solution_1.Solution.FloorInsulation]: new types_1.SubsidyDetails(11, { min: 20, max: 130 }),
            [solution_1.Solution.HybridHeatPump]: new types_1.SubsidyDetails(2400, { min: 1, max: 3 }),
            [solution_1.Solution.InnerRoofInsulation]: new types_1.SubsidyDetails(30, { min: 20, max: 200 }),
            [solution_1.Solution.Miscellaneous]: null,
            [solution_1.Solution.PvSystem]: null,
            [solution_1.Solution.Sedum]: null,
            [solution_1.Solution.WallInsulation]: new types_1.SubsidyDetails(8, { min: 10, max: 170 }),
            [solution_1.Solution.WindowFrames]: new types_1.SubsidyDetails(23, { min: 8, max: 45 }),
            [solution_1.Solution.WindowGlazing]: new types_1.SubsidyDetails(53, { min: 8, max: 45 }),
            [solution_1.Solution.UnderfloorHeating]: null,
            [solution_1.Solution.HomeBattery]: null,
        };
        /* the installable must be installed between 1 april 2021 and 31 dec. 2022 to have been eligible for subsidy in 2022 */
        this.eligibleWithin = {
            start: new Date('2021-04-01'),
            end: (0, dayjs_1.default)('2022-12-31').endOf('day').toDate(),
        };
    }
    isSubsidizableSolutions(...solutions) {
        const subsidizableSolutions = [...new Set(solutions)].filter(solution => this.getDetailsBySolution(solution) !== null);
        // - Vanaf 2022 is het niet meer mogelijk om vloer- en bodemisolatie te combineren om aan de isolatiewaarde eis te voldoen.
        if (subsidizableSolutions.includes(solution_1.Solution.FloorInsulation) &&
            subsidizableSolutions.includes(solution_1.Solution.CrawlspaceInsulation)) {
            (0, utils_1.remove)(subsidizableSolutions, solution_1.Solution.CrawlspaceInsulation);
        }
        // - Dakisolatie en zolder- of vlieringsvloerisolatie zijn niet te combineren als twee maatregelen.
        if (subsidizableSolutions.includes(solution_1.Solution.InnerRoofInsulation) &&
            subsidizableSolutions.includes(solution_1.Solution.AtticFloorInsulation)) {
            (0, utils_1.remove)(subsidizableSolutions, solution_1.Solution.AtticFloorInsulation);
        }
        return (subsidizableSolutions.length >= 2 ||
            subsidizableSolutions.includes(solution_1.Solution.ElectricHeatPump) ||
            subsidizableSolutions.includes(solution_1.Solution.HybridHeatPump));
    }
    forInstallables(installables) {
        // Note: subsidy on a set of installables can only be requested in the current year when the installables were all installed at most 1 year ago.
        // However, since 2022 is a previous year, we don't explicitly check that requirement anymore
        // so that we can use this class to support subsidy calculations for older quotes.
        // combine installables with the same solution
        installables = (0, utils_1.mergeSameSolutionInstallables)(installables);
        const solutions = installables.map(i => i.solution);
        // - Bij de isolatiemaatregel type vloer- of bodemisolatie kunt u ervoor kiezen om de vloer of de bodem te isoleren.
        // i.e., the customer may pick which one they will get subsidised. Obviously, we will pick the one which will net the most subsidy.
        if (solutions.includes(solution_1.Solution.FloorInsulation) &&
            solutions.includes(solution_1.Solution.CrawlspaceInsulation)) {
            const [floorInstallable, removeFloor] = (0, utils_1.findBySolution)(installables, solution_1.Solution.FloorInsulation); // eslint-disable-line prettier/prettier
            const [crawlspaceInstallable, removeCrawlspace] = (0, utils_1.findBySolution)(installables, solution_1.Solution.CrawlspaceInsulation); // eslint-disable-line prettier/prettier
            const floorSubsidy = this.forInstallable(floorInstallable);
            const crawlspaceSubsidy = this.forInstallable(crawlspaceInstallable);
            if (floorSubsidy > crawlspaceSubsidy) {
                removeCrawlspace();
            }
            else {
                removeFloor();
            }
        }
        // - Dakisolatie en zolder- of vlieringsvloerisolatie zijn niet te combineren als twee maatregelen.
        // i.e., the customer may pick which one they will get subsidised. Obviously, we will pick the one which will net the most subsidy.
        if (solutions.includes(solution_1.Solution.InnerRoofInsulation) &&
            solutions.includes(solution_1.Solution.AtticFloorInsulation)) {
            const [roofInstallable, removeRoof] = (0, utils_1.findBySolution)(installables, solution_1.Solution.InnerRoofInsulation); // eslint-disable-line prettier/prettier
            const [atticFloorInstallable, removeAtticFloor] = (0, utils_1.findBySolution)(installables, solution_1.Solution.AtticFloorInsulation); // eslint-disable-line prettier/prettier
            const roofSubsidy = this.forInstallable(roofInstallable);
            const atticFloorSubsidy = this.forInstallable(atticFloorInstallable);
            if (roofSubsidy > atticFloorSubsidy) {
                removeAtticFloor();
            }
            else {
                removeRoof();
            }
        }
        return (0, sum_1.sum)(installables.map(this.forInstallable.bind(this)));
    }
}
exports.ISDESubsidy2022 = ISDESubsidy2022;
